export interface DemoFormDefinition {
  identifier: string;
  title: string;
  route: string;
}

export const DEMO_FORMS: DemoFormDefinition[] = [
  {
    identifier: 'form-a',
    title: 'Formular A',
    route: '/forms/form-a'
  },
  {
    identifier: 'form-k',
    title: 'Formular K',
    route: '/forms/form-k'
  }
];

export const FORM_A_IDENTIFIER = 'form-a';
export const FORM_K_IDENTIFIER = 'form-k';
